import { render } from "./SurveyInputBirthday.vue?vue&type=template&id=56dcf1bc&ts=true"
import script from "./SurveyInputBirthday.vue?vue&type=script&lang=ts"
export * from "./SurveyInputBirthday.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__